import { formSubmitClear, formComplete } from 'actions/forms'
import { getPartnerChildrens } from 'actions/personalInfo'
import { notify } from '../utils/notification'
import { parseError, agent, updateSessionObject } from 'utils/api'
import constants from 'constants'
import { push } from 'react-router-redux'

export const PARTNERCHILDREN_SAVE_REQUEST = 'PARTNERCHILDREN_SAVE_REQUEST'
export const PARTNERCHILDREN_SAVE_ERROR = 'PARTNERCHILDREN_SAVE_ERROR'
export const PARTNERCHILDREN_SAVE_COMPLETE = 'PARTNERCHILDREN_SAVE_COMPLETE'

const savePartnerChildrenRequest = () => ({
  type: PARTNERCHILDREN_SAVE_REQUEST,
})

const savePartnerChildrenError = errors => ({
  error: errors[0].error,
  type: PARTNERCHILDREN_SAVE_ERROR,
})

const savePartnerChildrenComplete = result => ({
  result,
  type: PARTNERCHILDREN_SAVE_COMPLETE,
})

export const addPartnerChildren = (payload, formId, redirect = true) => (dispatch) => {
  dispatch(savePartnerChildrenRequest())
  agent.PartnerChildren.create(payload).then((response) => {
    dispatch(savePartnerChildrenComplete(response))
    dispatch(notify('Partner children saved'))

    if (redirect) {
      dispatch(getPartnerChildrens(payload.employee_id))
      // dispatch(push({ pathname: '/beneficiaries' }))
    }
    dispatch(formComplete(formId))
  }).catch((rawError) => {
    const { error, status, description } = parseError(rawError)
    if (status === constants.ERROR.INTERNAL_SERVER || status === constants.ERROR.SERVICE_UNAVAILABLE) {
      dispatch(push({
        pathname: '/error',
        search: `?type=${constants.ERROR.INTERNAL_SERVER}`,
      }))
    } else if (status === constants.ERROR.UNAUTHORIZED) {
      updateSessionObject()
    } else {
      dispatch(notify('Error saving partner children, please try again later', 'warning'))
      // console.warn('Err <addPartnerChildren>: ', description, error)
      dispatch(formSubmitClear(formId))
    }
  })
}

export const editPartnerChildren = (payload, formId, redirect = true) => (dispatch) => {
  dispatch(savePartnerChildrenRequest())
  agent.PartnerChildren.update(payload).then((response) => {
    dispatch(savePartnerChildrenComplete(response))
    dispatch(notify('Partner children saved'))

    if (redirect) {
      dispatch(getPartnerChildrens(payload.employee_id))
      // dispatch(push({ pathname: '/beneficiaries' }))
    }
    dispatch(formComplete(formId))
  }).catch((rawError) => {
    const { error, status, description } = parseError(rawError)
    if (status === constants.ERROR.INTERNAL_SERVER || status === constants.ERROR.SERVICE_UNAVAILABLE) {
      dispatch(push({
        pathname: '/error',
        search: `?type=${constants.ERROR.INTERNAL_SERVER}`,
      }))
    } else if (status === constants.ERROR.UNAUTHORIZED) {
      updateSessionObject()
    } else {
      dispatch(notify('Error saving partner children, please try again later', 'warning'))
      // console.warn('Err <editPartnerChildren>: ', description, error)
      dispatch(formSubmitClear(formId))
    }
  })
}

export const deletePartnerChildren = payload => (dispatch) => {
  dispatch(savePartnerChildrenRequest())
  agent.PartnerChildren.delete(payload).then((response) => {
    dispatch(savePartnerChildrenComplete(response))
    dispatch(notify('Partner children deleted'))
    dispatch(getPartnerChildrens(payload.employee_id))
    // dispatch(push({ pathname: '/beneficiaries' }))
    // dispatch(goBack)
  }).catch((rawError) => {
    const { error, status, description } = parseError(rawError)
    if (status === constants.ERROR.INTERNAL_SERVER || status === constants.ERROR.SERVICE_UNAVAILABLE) {
      dispatch(push({
        pathname: '/error',
        search: `?type=${constants.ERROR.INTERNAL_SERVER}`,
      }))
    } else if (status === constants.ERROR.UNAUTHORIZED) {
      updateSessionObject()
    } else {
      dispatch(notify('Error deleting partner children, please try again later', 'warning'))
      // console.warn('Err <deletePartnerChildren>: ', description, error)
      dispatch(savePartnerChildrenError(PARTNERCHILDREN_SAVE_ERROR))
    }
  })
}




// WEBPACK FOOTER //
// ./src/actions/partnerChildrenForm.js